import { render } from "./ManageSubModel.vue?vue&type=template&id=1a57a934&ts=true"
import script from "./ManageSubModel.vue?vue&type=script&lang=ts"
export * from "./ManageSubModel.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__